import React, { useState } from 'react';


const FALLBACK_BATCHES = [
  { _id: 'fb1', name: 'Ballet Foundations — Batch A', category: 'Ballet', feeAmount: 1800, isPopular: false, shortDesc: 'Master classical ballet postures, barre exercises, and grace.', startTime: '16:00', endTime: '17:30', tutor: { name: 'Ms. Clara Vance', email: 'clara@etsacademy.com' }, level: 'Beginner', days: ['Mon', 'Wed', 'Fri'] },
  { _id: 'fb2', name: 'Urban Street Hip Hop', category: 'Hip Hop', feeAmount: 1600, isPopular: true, shortDesc: 'High-energy choreography, popping, locking, and groove control.', startTime: '18:00', endTime: '19:30', tutor: { name: 'Marcus Jay', email: 'marcus@etsacademy.com' }, level: 'Intermediate', days: ['Tue', 'Thu'] },
  { _id: 'fb3', name: 'Contemporary Flow & Expression', category: 'Contemporary', feeAmount: 2000, isPopular: false, shortDesc: 'Fluid floorwork, emotional expression, and modern dance technique.', startTime: '10:00', endTime: '11:30', tutor: { name: 'Elena Rostova', email: 'elena@etsacademy.com' }, level: 'All Levels', days: ['Sat', 'Sun'] }
];

const getTermMonths = (start, end) => {
  if (!start || !end) return 12; // default standard annual (12 months)
  const d1 = new Date(start);
  const d2 = new Date(end);
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return 12;
  const diffTime = Math.abs(d2 - d1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const months = Math.round(diffDays / 30.4);
  return months || 1;
};

const tField = (field, lang = 'en') => {
  if (!field) return '';
  if (typeof field === 'string') return field;
  return field[lang] || field.en || '';
};

const tDay = (day, lang) => {
  if (lang !== 'zh') return day;
  const days = { 'Mon':'一', 'Tue':'二', 'Wed':'三', 'Thu':'四', 'Fri':'五', 'Sat':'六', 'Sun':'日' };
  return days[day] || day;
};

const tLevel = (lvl, lang) => {
  if (lang !== 'zh') return lvl;
  const levels = { 'Beginner':'初級', 'Intermediate':'中級', 'Advanced':'高級', 'All Levels':'所有級別' };
  return levels[lvl] || lvl;
};

export default function Pricing({ publicBatches = [], scrollTo, lang = 'en' }) {
  const displayBatches = (publicBatches && publicBatches.length > 0) ? publicBatches : FALLBACK_BATCHES;
  const [isAnnual, setIsAnnual] = useState(false);

  return (
    <section className="lp-sec" id="pricing">
      <div className="lp-container">
        <div className="reveal" style={{ textAlign: 'center' }}>
          <div className="lp-overline">{lang === 'zh' ? '簡單定價' : 'Simple Pricing'}</div>
          <h2 className="lp-sec-title">{lang === 'zh' ? '透明' : 'Transparent'} <em className="lp-text-gold">{lang === 'zh' ? '定價' : 'Pricing'}</em></h2>
          <div className="lp-billing-toggle">
            <span className={`lp-toggle-lbl ${!isAnnual ? 'active' : ''}`}>{lang === 'zh' ? '月繳' : 'Monthly'}</span>
            <button className={`lp-toggle-track ${isAnnual ? 'on' : ''}`} onClick={() => setIsAnnual(p => !p)}>
              <div className="lp-toggle-thumb" />
            </button>
            <span className={`lp-toggle-lbl ${isAnnual ? 'active' : ''}`}>{lang === 'zh' ? '全期 / 年繳' : 'Full Term / Annual'}</span>
            {isAnnual && <span className="lp-save-tag">{lang === 'zh' ? '節省 20%' : 'Save 20%'}</span>}
          </div>
        </div>
        <div className="lp-pricing-grid">
          {displayBatches.map((b, idx) => {
              const hasExplicitPopular = displayBatches.some(x => x.isPopular);
              const popular = hasExplicitPopular ? !!b.isPopular : idx === 1;
              const monthlyPrice = b.feeAmount || 1800;
              const termMonths = getTermMonths(b.startDate, b.endDate);
              
              const discountPercent = b.termDiscountPercent !== undefined && b.termDiscountPercent !== null ? b.termDiscountPercent : 20;
              const discountMultiplier = (100 - discountPercent) / 100;
              const fullTermPrice = Math.round(monthlyPrice * termMonths * discountMultiplier);
              const currentPrice = isAnnual ? fullTermPrice : monthlyPrice;
              
              const periodSuffix = isAnnual 
                ? (termMonths === 12 ? (lang==='zh'?'/年':'/yr') : (lang==='zh'?`/期 (${termMonths}個月)`:`/term (${termMonths} mos)`)) 
                : (lang==='zh'?'/月':'/mo');

              return (
                <div key={b._id} className={`lp-plan-card ${popular ? 'popular' : ''}`}>
                  {popular && <div className="lp-plan-popular-tag">{lang === 'zh' ? '最暢銷' : 'Best Seller'}</div>}
                  <div className="lp-plan-name">{tField(b.name, lang)}</div>
                  <div className="lp-plan-price" style={{ display: 'flex', alignItems: 'baseline', gap: 6, flexWrap: 'wrap' }}>
                    <span className="lp-plan-currency">HK$</span>
                    <span className="lp-plan-amount">{currentPrice.toLocaleString()}</span>
                    <span className="lp-plan-period">{periodSuffix}</span>
                    {isAnnual && discountPercent > 0 && (
                      <span className="lp-save-tag" style={{ fontSize: 11, padding: '2px 8px', borderRadius: 4, whiteSpace: 'nowrap' }}>
                        {lang === 'zh' ? `節省 ${discountPercent}%` : `Save ${discountPercent}%`}
                      </span>
                    )}
                  </div>
                  <div className="lp-plan-desc">{tField(b.shortDesc, lang) || (lang === 'zh' ? `立即加入我們的優質 ${tField(b.category, lang) || tField(b.name, lang)} 舞蹈班！` : `Join our premium ${tField(b.category, lang) || tField(b.name, lang)} dance batch today!`)}</div>
                  <div className="lp-plan-feats">
                    <div className="lp-plan-feat-row">
                      <div className="lp-plan-check">✓</div>
                      <span className="lp-plan-feat-on">{b.days?.length || 0} {lang === 'zh' ? '節/週' : 'Sessions/week'} ({b.days?.map(d => lang === 'zh' ? `週${tDay(d, lang)}` : d).join(', ')})</span>
                    </div>
                    <div className="lp-plan-feat-row">
                      <div className="lp-plan-check">✓</div>
                      <span className="lp-plan-feat-on">⏱ {b.startTime} - {b.endTime}</span>
                    </div>
                    <div className="lp-plan-feat-row" style={{ alignItems: 'flex-start' }}>
                      <div className="lp-plan-check" style={{ marginTop: 2 }}>✓</div>
                      <div>
                        <span className="lp-plan-feat-on" style={{ display: 'block' }}>🎓 {lang === 'zh' ? '導師：' : 'Instructor: '} {tField(b.tutor?.name, lang) || (lang === 'zh' ? '待定' : 'TBA')}</span>
                        {b.tutor?.email && <span className="lp-plan-feat-on" style={{ fontSize: 11, display: 'block', color: '#888', marginTop: 2 }}>📧 {b.tutor.email}</span>}
                      </div>
                    </div>
                    <div className="lp-plan-feat-row">
                      <div className="lp-plan-check">✓</div>
                      <span className="lp-plan-feat-on">🎯 {lang === 'zh' ? '課程級別：' : 'Curriculum Level: '} {tLevel(b.level, lang)}</span>
                    </div>
                    <div className="lp-plan-feat-row">
                      <div className="lp-plan-check">✓</div>
                      <span className="lp-plan-feat-on">👥 {lang === 'zh' ? `名額限制 ${b.maxStudents} 人` : `Limited to ${b.maxStudents} students max`}</span>
                    </div>
                    <div className="lp-plan-feat-row">
                      <div className="lp-plan-check">✓</div>
                      <span className="lp-plan-feat-on">📝 {lang === 'zh' ? '定期導師反饋與筆記' : 'Dated Tutor Feedback & Notes'}</span>
                    </div>
                    <div className="lp-plan-feat-row">
                      <div className="lp-plan-check">✓</div>
                      <span className="lp-plan-feat-on">⭐ {lang === 'zh' ? '成就徽章與專屬介面' : 'Achievement Badges & Portals'}</span>
                    </div>
                    {b.offeredMerchandise && b.offeredMerchandise.length > 0 && (
                      <div className="lp-plan-feat-row" style={{ marginTop: 8, paddingTop: 8, borderTop: '1px dashed rgba(0,0,0,0.1)' }}>
                        <div className="lp-plan-check" style={{ background: 'var(--wine)', color: 'white' }}>🎁</div>
                        <span className="lp-plan-feat-on" style={{ fontWeight: 600, color: 'var(--wine)' }}>
                          {lang === 'zh' ? '免費贈送：' : 'Complimentary: '} {b.offeredMerchandise.map(m => lang === 'zh' ? `${tField(m.name, lang)} (價值 HK$ ${m.price})` : `${tField(m.name, lang)} (Value HK$ ${m.price})`).join(', ')}
                        </span>
                      </div>
                    )}
                  </div>
                  <button className={`btn ${popular ? 'btn-primary' : 'btn-outline'}`} style={{ width: '100%', justifyContent: 'center', marginTop: 'auto' }} onClick={() => scrollTo('contact')}>
                    {lang === 'zh' ? `查詢 ${tField(b.name, lang)}` : `Enquire for ${tField(b.name, lang)}`}
                  </button>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
}
